module.exports = __webpack_public_path__ + "images/li.jpg";


//////////////////
// WEBPACK FOOTER
// ./vively/images/social-media-icons/li.jpg
// module id = 874
// module chunks = 3